module.exports = "/_next/static/images/Features-51d2e79e2723370ba068ced669ca2173.webp";